import React, { useEffect, useState } from "react";
import { IUIPropertyDefinitionMap, IWidgetTemplateProps, PropertyPath, addToPath, registerCardTemplate, registerMobileCardTemplate } from "../../../common/common";
import { WidgetWrapper, useEffectWithPolling } from "uxp/components";
import './CardListTemplate.scss'
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import { SelectableItem, selectUIProps, selectUIPropsForMobileTempaltes } from "../../../common/SelectableItem";
import { TextProperty, extractTextProperties } from "../../../common/ui-props/TextProperty";
import classNames from "classnames";
import { CardListProperty } from "./CardListProperty";
import { CardList, ICardListProps } from "../../../common/components/card-list/CardList";
import { executeAndBind } from "../../../common/data-source-picker/datasource";
import { extractContextData, hasValue, loadInitialData, updateParentUIPropsWithDefaultWidgetUIProps } from "../../../../util";

const defaultCardProps: ICardListProps = {
    imageField: `{$.row.image}`,
    titleField: `{$.row.title}`,
    subTitleField: `{$.row.subTitle}`,
    imagePosition: '',
    imageSize: '',
    titleColor: '',
    titleSize: '',
    subTitleColor: '',
    subTitleSize: '',
    binding: null,
    fields: [],
    aspectRatio: '',
    height: '',
    marginBottom: '',
    marginTop: '',
    onClick: {
        type: "open-url"
    }
}

let defaultCardItems = [
    {
        title: "4x4 Sight Seeing Tour in Al Ula",
        subTitle: "Start your day with a thrilling 4x4 dune bashing experience in the desert.",
        image: "https://picsum.photos/id/83/600/600"
    },
    {
        title: "3 Hour Al Ula Hiking Adventure",
        subTitle: "Head to the Dhihin Desert Oasis and take a refreshing dip in the clear waters.",
        image: "https://picsum.photos/id/84/600/600"
    },
    {
        title: "Hourse Riding Through Farm In Madinah",
        subTitle: "Horseback ride through Madinah's picturesque farmlands—a serene and rustic journey.",
        image: "https://picsum.photos/id/62/600/600"
    }
]

const CardListWidget: React.FunctionComponent<IWidgetTemplateProps> = (props) => {

    const { designer, uxpContext, instanceId, index } = props
    const isDesignMode = props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')

    let uiProps = props?.uiProps || {};

    // updating default values
    const _cardList: ICardListProps = { ...uiProps?.cardList || {} }
    if (isDesignMode) {
        if (!hasValue(_cardList.imageField)) _cardList.imageField = `{$.row.image}`
        if (!hasValue(_cardList.titleField)) _cardList.titleField = `{$.row.title}`
        if (!hasValue(_cardList.subTitleField)) _cardList.subTitleField = `{$.row.subTitle}`
        if (!hasValue(_cardList.imagePosition)) _cardList.imagePosition = ''
        if (!hasValue(_cardList.imageSize)) _cardList.imageSize = ''
        if (!hasValue(_cardList.titleColor)) _cardList.titleColor = ''
        if (!hasValue(_cardList.titleSize)) _cardList.titleSize = ''
        if (!hasValue(_cardList.subTitleColor)) _cardList.subTitleColor = ''
        if (!hasValue(_cardList.subTitleSize)) _cardList.subTitleSize = ''
        if (!hasValue(_cardList.binding)) _cardList.binding = null
        if (!hasValue(_cardList.aspectRatio)) _cardList.aspectRatio = ''
        if (!hasValue(_cardList.height)) _cardList.height = ''
        if (!hasValue(_cardList.marginBottom)) _cardList.marginBottom = ''
        if (!hasValue(_cardList.marginTop)) _cardList.marginTop = ''
        if (!hasValue(_cardList.onClick)) _cardList.onClick = { type: 'open-url' }
        if (!hasValue(_cardList.bgColor)) _cardList.bgColor = '#f3f3f3'
        if (!hasValue(_cardList.type)) _cardList.type = 'card-1'
        if (!hasValue(_cardList.buttonLabel)) _cardList.buttonLabel = ''
        if (!hasValue(_cardList.buttonBG)) _cardList.buttonBG = ''
        if (!hasValue(_cardList.buttonLabelColor)) _cardList.buttonLabelColor = ''
        if (!_cardList?.fields) _cardList.fields = []
    }
    uiProps.cardList = _cardList
    // need to pass the global uiProps to selectable
    const parentUIProps = updateParentUIPropsWithDefaultWidgetUIProps(props.parentUIProps, uiProps, index)


    const [items, setItems] = useState<any[]>(defaultCardItems)
    const [contextData, setContextData] = useState({})
    const dataSourcesPath: PropertyPath = designer?.isMobile ? addToPath('fields', index, 'props', 'uiProps', 'datasources') : 'datasources'

    const XPRProps: IUIPropertyDefinitionMap = {
        'container': ContainerProperty({
            background: {
                image: {
                    image: '',
                    size: '',
                    position: '',
                },
                color: ''
            },
            removeShadow: false
        }),
        'headerContainer': ContainerProperty({
            background: { color: '' }
        }),
        'title': TextProperty({ text: 'Title', size: '14px', color: '' }, 'Title'),
        'subTitle': TextProperty({ text: 'Sub Title', size: '11px', color: '' }, 'Sub Title'),
        'headerAction': TextProperty({ text: 'See more', size: '11px', color: '' }, 'Action'),
        'cardList': CardListProperty({
            imageField: '',
            titleField: '',
            subTitleField: '',
            imageSize: 'cover',
            imagePosition: '',
            fields: []
        }, dataSourcesPath)
    }

    const { styles: containerStyles } = extractContainerProperties(uiProps.container)
    const { styles: headerStyles } = extractContainerProperties(uiProps.headerContainer)
    const { text: title, styles: titleStyles } = extractTextProperties(uiProps.title, 'Title')
    const { text: subTitle, styles: subTitleStyles } = extractTextProperties(uiProps.subTitle, 'Sub title')
    const { text: actionLabel, styles: actionLabelStyles } = extractTextProperties(uiProps.headerAction, 'See more')

    useEffectWithPolling(uxpContext, 'channel', 5000, async () => {

        if (uiProps?.cardList?.binding) {
            executeAndBind(uxpContext, uiProps?.cardList?.binding, uiProps?.datasources || [], {}, {})
                .then(res => setItems(res))
                .catch(e => {
                    setItems([])
                    console.log('unable to get items in card list. exception : ', e)
                })
        }
        else {
            setItems(defaultCardItems)
        }
    }, [uiProps, designer])

    React.useEffect(() => {
        loadInitialDataAndContextData()
    }, [props])

    useEffect(() => {
        console.log('data__source________ppp', uiProps)
    }, [uiProps])

    async function loadInitialDataAndContextData() {
        const { isLoading, initialData } = await loadInitialData(props)
        const _data = await extractContextData(props, initialData, contextData)
        setContextData(_data)
    }

    return <WidgetWrapper className={classNames("uxp-card-list-widget-wrapper", { 'no-shadow': uiProps?.container?.removeShadow })}>
        <div className="container" style={containerStyles} >

            <div className="content">

                <div className="header" style={headerStyles}>
                    <SelectableItem
                        designer={designer}
                        props={selectUIPropsForMobileTempaltes(parentUIProps, XPRProps, index, {}, 'headerContainer', 'title', 'subTitle', 'headerAction')}
                        elementId={instanceId}
                    >
                        <div className="header-content">
                            <div className="titles">
                                <div className="title" style={titleStyles}>{title}</div>
                                <div className="sub-title" style={subTitleStyles}>{subTitle}</div>
                            </div>
                            <div className="actions" style={actionLabelStyles} >
                                {actionLabel}
                            </div>
                        </div>
                    </SelectableItem>
                </div>

                <div className="body">
                    <SelectableItem
                        designer={designer}
                        props={selectUIPropsForMobileTempaltes(parentUIProps, XPRProps, index, { datasources: dataSourcesPath }, 'container', 'cardList')}
                        elementId={instanceId}
                    >
                        <div className="body-content">
                            <CardList
                                designer={designer}
                                uxpContext={uxpContext}
                                items={items}
                                cardListProps={uiProps?.cardList}
                                contextData={contextData}
                                onChangeContextData={(data) => {
                                    setContextData(data)
                                }}
                                onChangeFields={(newFields) => {
                                    if (designer?.isMobile) {
                                        const updatedProps = Object.assign({}, uiProps, { 'fields': newFields })
                                        designer?.setMobileCardUIProps(instanceId, updatedProps, 'fields')
                                    }
                                    else {
                                        designer?.setUIProps(Object.assign({}, uiProps, { 'fields': newFields }))
                                    }
                                }}
                                uiProps={uiProps}
                                instanceId={instanceId}
                                propPath={['fields', index, 'props', 'uiProps', 'fields']}
                            />
                        </div>
                    </SelectableItem>
                </div>
            </div>
        </div>
    </WidgetWrapper>
}


registerCardTemplate({
    id: 'card-list',
    template: CardListWidget,
    name: 'Card List',
    description: 'Scrollable Card List',
    complexity: 'easy',
    layout: {
        w: 9,
        h: 8
    },
    canDragDropFields: true
});

registerMobileCardTemplate({
    id: 'card-list',
    template: CardListWidget,
    name: 'Card List',
    description: 'Horizontal list of cards'
})